// A HOF that when given a simple reducer function, returns a regular reducer
// function which in turn calls the simple reducer function with `state` from
// the regular reducer function as well as the extracted `payload` from the
// action object.
//
// For example, instead of writing reducer functions like:
//
// ```
// export default handleActions({
//   [MY_ACTION]: (state, action) {
//     return {
//       ...state,
//       something: action.payload.something
//     };
//   }
// });
// ```
// ... by using the `withPayload` HOF, we can remove the layer of data
// abstraction around `action` and access the action's `payload` directly:
//
// ```
// export default handleActions({
//   [MY_ACTION]: (state, { something }) {
//     return {
//       ...state,
//       something
//     };
//   }
// });
// ```
export const withPayload =
  (simpleReducerFunc: any) =>
  (state: any, {payload}: any) =>
    simpleReducerFunc(state, payload);
